export default __webpack_public_path__ + "content/media/19.bd934d7a.jpg";